import React from 'react';
import strings from 'strings';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const COPIES = strings.sendoutsV2.drawers.tabs.activityLogs;
export const PAGE_KEY = PERSISTENCE_KEYS.SENDOUTS.ACTIVITY_LOGS;

export const ACTIVITY_LOGS_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'description',
    label: 'Description',
    options: {
      filter: true,
      sort: false,
      display: true,
      renderer: value => React.createElement(FPHtmlViewer, { content: value })
    }
  },
  {
    name: 'user.fullName',
    label: COPIES.user,
    options: {
      sort: false,
      display: false
    }
  },
  {
    name: 'createdAt',
    label: 'Created At',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'createdAt',
  direction: 'desc'
};
